"use client"

import { useEffect, useState } from "react"

export function getTimeRemaining(endDate: string, now: Date) {
  const diff = new Date(endDate).getTime() - now.getTime()
  if (diff <= 0) {
    return { expired: true, hours: 0, minutes: 0, seconds: 0 }
  }
  const totalSeconds = Math.floor(diff / 1000)
  return {
    expired: false,
    // Days are intentionally not displayed (matching the reference site's
    // own countdown, which also computes but hides a days field) — hours
    // is the remainder after days, so it always reads 0-23, not a
    // three-digit total hour count.
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  }
}

function pad(n: number) {
  return n.toString().padStart(2, "0")
}

export default function Countdown({ endDate }: { endDate: string }) {
  const [remaining, setRemaining] = useState<ReturnType<
    typeof getTimeRemaining
  > | null>(null)

  useEffect(() => {
    const tick = () => setRemaining(getTimeRemaining(endDate, new Date()))
    tick()
    const timer = setInterval(tick, 1000)
    return () => clearInterval(timer)
  }, [endDate])

  // Render nothing until mounted — avoids a hydration mismatch, since the
  // server has no notion of "now" and would render a different time than
  // the client's first paint.
  if (!remaining || remaining.expired) return null

  return (
    <span className="text-xs font-bold tabular-nums">
      {pad(remaining.hours)}:{pad(remaining.minutes)}:{pad(remaining.seconds)}
    </span>
  )
}
